import { render, staticRenderFns } from "./photoCellElement_copy.vue?vue&type=template&id=61d2003e&scoped=true&"
import script from "./photoCellElement_copy.vue?vue&type=script&lang=js&"
export * from "./photoCellElement_copy.vue?vue&type=script&lang=js&"
import style0 from "./photoCellElement_copy.vue?vue&type=style&index=0&id=61d2003e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d2003e",
  null
  
)

export default component.exports